// extracted by mini-css-extract-plugin
module.exports = {"Title":"EditorialIntro_Title__2My84","Description":"EditorialIntro_Description__16FFZ"};